import React from "react"
import { withRouter } from "react-router-dom"
import Base from "./Base"
import StepsUserFormBase from './StepsUserFormBase'
import MercadoPagoMP from "../../Components/Payments/MercadoPagoMP"
import { Spin, Row, Col} from "antd"
import { connect } from "react-redux"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"

class MercadoPagoPayment extends React.Component {
    render() {
        if (this.props.match.params.id === null || this.props.match.params.id === undefined){
            return (<>
            <Row></Row>
            <Row type="flex" justify="space-around" align="middle" style={{marginTop:'150px'}}>
                <Col style={{minHeight:'360px'}}>
                    <Spin indicator={CustomSpinner}/>
                </Col>
            </Row>
            <Row></Row>
            </>)
        } else {
            return(
                <StepsUserFormBase title='Pago'>
                    <MercadoPagoMP
                        plan_id={this.props.match.params.id}
                        stepsUser={true}
                    >
                    </MercadoPagoMP>
                </StepsUserFormBase>
            )
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MercadoPagoPayment));